import { createContext } from "react"

export const QuantityContext = createContext({});